import { call, put, takeLatest } from "redux-saga/effects";
import {
	LedgerApiErrorAction,
	SapLedger_Go_Button_API_Success, ProductMargin_Go_Btn_Success
} from "./action";
import { Get_Product_Margin_Report, PartyLedger_API, } from "../../../helpers/backend_helper";
import { PRODUCTMARGIN_GO_BTN_ACTION, GO_BUTTON_API_SAP_LEDGER, } from "./actionType";
import SERVER_HOST_PATH from "../../../helpers/_serverPath";


function* SapLedger_GoBtn_GenFuc({ filters }) {

	try {

		const response = yield call(PartyLedger_API, filters);
		let TotalDebitAmount = 0
		let TotalCreditAmount = 0
		let TotalBalance = 0

		let NewResponse

		if (response.Data.status_code === 200) {
			const newresponse = yield response.Data.data.map((i, key) => {
				
				i.id = key + 1
				if (i.DebitCredit === "S") {
					i.Debit_Amount = i.Amount
					TotalDebitAmount = Number(TotalDebitAmount) + Number(i.Debit_Amount)
				}
				if (i.DebitCredit === "H") {
					i.Credit_Amount = i.Amount
					TotalCreditAmount = Number(TotalCreditAmount) + Number(i.Credit_Amount)
				}
				return i
			})

			newresponse.push({
				id: response.length - 1,
				PostingDate: "Total",
				Credit_Amount: TotalCreditAmount.toFixed(2),
				Debit_Amount: TotalDebitAmount.toFixed(2),
		

			})

			NewResponse = {
				Status: true,
				StatusCode: 200,
				count: response.Data.count,
				OpeningBal: response.Data.OpeningBal,
				ClosingBal: response.Data.ClosingBal,
				tableData: newresponse
			};
		}
		else {

			NewResponse = {
				Status: true,
				StatusCode: 204,
				tableData: []
			};
		}

		yield put(SapLedger_Go_Button_API_Success(NewResponse));

	} catch (error) { yield put(LedgerApiErrorAction()) }
}

function* ProductMarginGoBtn_GenFuc({ config }) {
	try {
	  const response = yield call(Get_Product_Margin_Report, config);
  
	  if (response?.StatusCode !== 200 || !Array.isArray(response.Data)) {
		yield put(ProductMargin_Go_Btn_Success([]));
		return;
	  }
  
	  const cleanedData = response.Data.map((item, index) => {
		// clone to avoid mutation
		const obj = { ...item };
  
		// optional: add row id for table
		// obj.id = index + 1;
  
		// remove backend-only IDs if not needed in UI
		delete obj.ProductID;
		delete obj.SubProductID;
		delete obj.BaseUnitID_id;
  
		// OPTIONAL: convert numeric strings to numbers
		Object.keys(obj).forEach(key => {
		  if (
			typeof obj[key] === "string" &&
			!isNaN(obj[key]) &&
			obj[key].trim() !== ""
		  ) {
			obj[key] = Number(obj[key]);
		  }
		});
  
		return obj;
	  });
  
	  yield put(ProductMargin_Go_Btn_Success(cleanedData));
	} catch (error) {
	  yield put(ProductMargin_Go_Btn_Success([]));
	  yield put(LedgerApiErrorAction());
	}
  }
  

function* SapLedgerSaga() {
	yield takeLatest(GO_BUTTON_API_SAP_LEDGER, SapLedger_GoBtn_GenFuc)
	yield takeLatest(PRODUCTMARGIN_GO_BTN_ACTION, ProductMarginGoBtn_GenFuc)
}

export default SapLedgerSaga;
